import script from "./account_set.vue?vue&type=script&setup=true&lang=js"
export * from "./account_set.vue?vue&type=script&setup=true&lang=js"

import "./account_set.vue?vue&type=style&index=0&id=4cb35305&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb35305"]])

export default __exports__